import { apiClient } from './client';

/**
 * PAYROLL API client — backend `apps/chat-server/src/modules/payroll/payroll.routes.ts` 와 1:1.
 *
 * out-of-scope: PDF endpoint (deferred).
 */

export interface PayrollListItemDto {
  id: string;
  year: number;
  month: number;
  /** "2025-08" 같은 표시 라벨. */
  label: string;
  netPay: number;
}

export interface PayrollDetailDto {
  id: string;
  year: number;
  month: number;
  payDate: string;
  earnings: {
    baseSalary: number;
    overtimePay: number;
    bonus: number;
    total: number;
  };
  deductions: {
    incomeTax: number;
    nationalPension: number;
    healthInsurance: number;
    employmentInsurance: number;
    total: number;
  };
  netPay: number;
}

export async function listPayrollStatements(): Promise<PayrollListItemDto[]> {
  const res = await apiClient.get<{ items: PayrollListItemDto[] }>('/payroll/statements');
  return Array.isArray(res.data?.items) ? res.data.items : [];
}

export async function getPayrollStatement(id: string): Promise<PayrollDetailDto> {
  const res = await apiClient.get<{ statement: PayrollDetailDto }>(`/payroll/statements/${id}`);
  return res.data.statement;
}
